import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=d2a4fcee&scoped=true&"
import script from "./Socials.vue?vue&type=script&lang=js&"
export * from "./Socials.vue?vue&type=script&lang=js&"
import style0 from "./Socials.vue?vue&type=style&index=0&id=d2a4fcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a4fcee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a4fcee')) {
      api.createRecord('d2a4fcee', component.options)
    } else {
      api.reload('d2a4fcee', component.options)
    }
    module.hot.accept("./Socials.vue?vue&type=template&id=d2a4fcee&scoped=true&", function () {
      api.rerender('d2a4fcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Socials.vue"
export default component.exports